import { Component, OnInit, ViewChild } from '@angular/core';
import { ThesisOrderMail } from '../../components/thesis-order-mail/thesis-order-mail';
import { ThesisOrderModel } from '../../../../models/thesis-order.model';

@Component({
  selector: 'smart-originality-send-mail-section',
  templateUrl: './originality-send-mail-section.component.html',
  styleUrls: ['./originality-send-mail-section.component.scss']
})
export class OriginalitySendMailSectionComponent implements OnInit {

  @ViewChild(ThesisOrderMail, {static: false}) thesisOrderMail: ThesisOrderMail;

  constructor() { }

  ngOnInit() {
  }

  sendThesisOrderEmail() {
    this.thesisOrderMail.openModal(new ThesisOrderModel(), () => {
    });
  }

}
